const redirect = (e, path, _blank, query = {}) => {
  if (_blank) {
    let routeUrl = e.$router.resolve({
      path: path,
      query: query,
    });
    window.open(routeUrl.href, '_blank');
  } else {
    e.$router.push({ path: path })
  }

}

// 动态加载js
const loadScript = (url, callback) => {
  if (typeof document !== "undefined") {
    var script = document.createElement("script");
  }
  script.type = "text/javascript";
  if (typeof callback !== "undefined") {
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState === "loaded" || script.readyState === "complete") {
          script.onreadystatechange = null;
          callback();
        }
      };
    } else {
      script.onload = function () {
        callback();
      };
    }
  }
  script.src = url;
  if (typeof document !== "undefined") {
    document.head.appendChild(script);
  }
}

const loadStatistics = function () {
  if (typeof document !== "undefined") {
    var script1 = document.createElement("script");
    script1.type = "text/javascript";
    script1.src = 'https://s4.cnzz.com/z_stat.php?id=1280321318&web_id=1280321318';
    var outer = document.createElement("div");
    outer.style.height = '1px';
    outer.style.width = '1px';
    outer.style.overflow = 'hidden';
    outer.appendChild(script1);

    var script2 = document.createElement("script");
    script2.type = "text/javascript";
    script2.src = "https://hm.baidu.com/hm.js?dae78368ac5493c2f47732c49bca8237";

    document.body.append(outer);
    document.body.append(script2);
  }
}

// 设置标题
const setTitle = (title) => {
  let schoolname = localStorage.getItem('schoolname');
  if (schoolname) {
    switch (title) {
      case 'Home':
        title = `${schoolname ? schoolname : ''}`
        break;
      case '学校概况':
      case '资讯':
        title = `${title}${schoolname ? '-' + schoolname : ''}`
        break;
      case '资讯查看':
        title = '-' + `${schoolname ? schoolname : ''}`
        break;
      case '课程查看':
      case '课程播放':
        title = '课程'
        break;
      default:
    }
  }
  if (title) {
    if (title == "首页") {
      title = "中教云课-全媒体人才培养实训教学平台"
    } else if (title == "思政资源库") {
      title = title + '-中国教育在线';
    } else if (title.indexOf("党建思政教育资源平台") > -1) {
      title = title + '-杭州职业技术学院'
    } else {
      title = title + '-中教云课';
    }
  } else {
    title = '中教云课-在线教育学习平台'
  }
  document.title = title
}
const schoolCode = localStorage.getItem("schoolCode")
// localStorage方法
const setUserInfo = val => localStorage.setItem('userInfo', JSON.stringify(val));
const getUserInfo = () => {
  return JSON.parse(localStorage.getItem('userInfo'));
};
const removeUserInfo = () => localStorage.removeItem('userInfo');
const clearLocal = () => localStorage.clear();

// 白名单路由不校验登录状态
const whiteList = ["/Page404", "/Error", "/class", "/notfound", `/${schoolCode}/hzvtc`, `/${schoolCode}/hzvtc/list`];

// 需要校验登录状态黑名单路由
const routers = ['studyRecord', 'myClass', 'myNote', 'myPractice', 'myAssess', 'myPractice/AgainPractice', 'myPractice/NowPractice', 'myAssess/assessAnswer', 'myAssess/againAssess', 'userMessage', 'userMessage/bindPhone', 'userMessage/modifyPhone', 'userMessage/modifyEmail', 'updatePassword'];
const blackList = routers.map((data) => {
  return '/user/' + data
})

const getUrlSchoolCode = (url) => {
  let code = ''
  if (url) {
    let arr = url.split("/");
    code = arr[2]
  }
  return code
}
export default {
  blackList,
  whiteList,
  getUrlSchoolCode,
  redirect,
  loadScript,
  setTitle,
  loadStatistics,
  setUserInfo,
  getUserInfo,
  removeUserInfo,
  clearLocal,
}
